import React, { useState } from 'react'
import { HubConnection } from "@microsoft/signalr";
import useLiveNotificationSender from '../../../_services/radacad-academy-signalRHub/react-hooks/useLiveNotificationSender'
import HTMLEditor from '../../_commons/Editor/HTMLEditor'
import { withHubConnection } from '../../../_services/radacad-academy-signalRHub/react-hocs/withHubConnection';
import LiveNotificationManagement from './LiveNotificationManagement';

export default function NotificationManagement(){

    return <LiveNotificationManagement/>
}